/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Left_LabelInputs */

const en_diff_left_label = /** @type {(inputs: Diff_Left_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Left (Original)`)
};

const ko_diff_left_label = /** @type {(inputs: Diff_Left_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`왼쪽 (원본)`)
};

const ja_diff_left_label = /** @type {(inputs: Diff_Left_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左（元のJSON）`)
};

/**
* | output |
* | --- |
* | "Left (Original)" |
*
* @param {Diff_Left_LabelInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_left_label = /** @type {((inputs?: Diff_Left_LabelInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Left_LabelInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_left_label(inputs)
	if (locale === "ko") return ko_diff_left_label(inputs)
	return ja_diff_left_label(inputs)
});